import { render } from "./VnRules.vue?vue&type=template&id=7d1e4049&scoped=true"
const script = {}

import "./VnRules.vue?vue&type=style&index=0&id=7d1e4049&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7d1e4049"

export default script